import moment from 'moment';
import { getText } from '../../lib/utils/langTexts'

const ProductComicsSpecificsDetails = ({productData, webTexts}) => {    
    return (        
        <>
            {productData?.originalEdition != "" && <p><b>{getText(webTexts,"DET003")}: </b> {productData?.originalEdition} </p>}
            {productData?.formatText != "" && <p><b>{getText(webTexts,"DET004")}: </b> {`${productData?.formatText}`} </p>}                            
            {productData?.editionDate && <p><b>{getText(webTexts,"DET005")}: </b>{moment(productData?.editionDate).format('DD/MM/YYYY')}</p>}
            <br/>
            {productData?.isbn != "" && <p><b>ISBN: </b> {productData?.isbn} </p>}
            {/*productData?.barcode != "" && <p><b>EAN: </b> {productData?.barcode} </p>*/}  
        </>
    );
};


export default ProductComicsSpecificsDetails;
